var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('TransactionListTemplate',{ref:"customer-sample-request-list",attrs:{"screenConfig":_vm.setScreenConfig,"rowClick":_vm.rowClickCallBack,"setLoading":_vm.setLoading,"persistenceKey":'customer-sample-request-list',"loadDataGrid":_vm.loaded}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }